import React, { useState } from 'react';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import Footer from '../footer';
import { Link, Navigate, useNavigate } from 'react-router-dom';

const PayRollview = () => {
    const navigate = useNavigate();
    const [filters, setFilters] = useState();
    const [currentRows, setcurrentRows] = useState();
    const handleDelete = async () => {


    }
    const [payrollView, setPayrollView] = useState([
        {
            id: 1,
            paid_by: 'Admin',
            amount: 20000,
            month: 'July',
            total_salary: 50000
        },
        {
            id: 2,
            paid_by: 'HR',
            amount: 30000,
            month: 'July',
            total_salary: 50000
        }
    ]);

    return (
        <div>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid py-4">

                                {/* Filter & Actions */}
                                <div className="card p-3 mb-4">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h3 className="text-primary">Payroll Records</h3>

                                        <div className="text-end">

                                            <button className="btn btn-sm btn-warning d-inline-flex align-items-center overflow-hidden  transition-button">
                                                <span className="icon">
                                                    {" "}
                                                    <i className="bi bi-printer"></i>
                                                </span>
                                                <span className="text ms-2">Print</span>
                                            </button>
                                            <button className="btn btn-info btn-sm text-white d-inline-flex align-items-center overflow-hidden  transition-button mx-2">
                                                <span className="icon">
                                                    {" "}
                                                    <i className="bi bi-file-earmark-excel"></i>
                                                </span>
                                                <span className="text ms-2">Export Excel</span>
                                            </button>
                                            <Link to="/payroll" className="btn btn-outline-danger btn-sm">Go Back</Link>
                                        </div>
                                    </div>


                                </div>

                                {/* Payroll Table */}
                                <div className="card">
                                    <div className="card-header  fw-bold">Payroll History</div>
                                    <div className="table-responsive p-4">
                                        <table className="table table-hover text-center m-0">
                                            <thead className="table">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Paid By</th>
                                                    <th>Amount</th>
                                                    <th>Month</th>
                                                    <th>Total Salary</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {payrollView?.length > 0 ? (
                                                    payrollView.map((item, index) => (
                                                        <tr key={item.id || index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.paid_by}</td>
                                                            <td>₹{item.amount}</td>
                                                            <td>{item.month}</td>
                                                            <td>₹{item.total_salary}</td>
                                                            <td> <button className="btn btn-sm btn-primary mx-2"><i className="bi bi-pencil-square"></i>
                                                                </button>
                                                                <button className="btn btn-sm btn-danger"><i className='bi bi-trash'></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-danger">No Payroll Records Found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>


                                </div>

                                <Footer />
                                <div className="content-backdrop fade"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PayRollview;
